(() => {
  window.Express = window.Express || {};

  function toClassList(value) {
    if (!value) return [];
    if (Array.isArray(value)) return value.flatMap(toClassList);
    return String(value).split(/\s+/).filter(Boolean);
  }

  function toVariantClass(variant) {
    const value = String(variant || '').trim();
    if (!value) return '';
    return value.startsWith('express-skeleton') ? value : `express-skeleton--${value}`;
  }

  function createBlock(options = {}) {
    const {
      tagName = 'span',
      className = '',
      classes = [],
      variant = 'block',
      variants = [],
      ariaHidden = true,
    } = typeof options === 'string' ? { className: options } : options;
    const block = document.createElement(tagName || 'span');
    const variantClasses = [...new Set(toClassList([variant, variants]).map(toVariantClass).filter(Boolean))];

    block.className = [
      'express-skeleton',
      ...variantClasses,
      ...toClassList([className, classes]),
    ].join(' ');

    if (ariaHidden) block.setAttribute('aria-hidden', 'true');
    return block;
  }

  window.Express.loadingSkeleton = window.Express.loadingSkeleton || {
    createBlock,
    createSkeletonBlock: createBlock,
  };
})();
